import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ArchivedIcon',
  props: {
    toolTipText: { default: "" }
  },
  setup(__props: any) {

const props = __props as { toolTipText: string };


const { toolTipText } = toRefs(props);
const isDisabled = computed(() => toolTipText.value.length === 0);

return { __sfc: true,props, toolTipText, isDisabled }
}

})